import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { convertDateOnlyStringToDate, convertDateToDateOnlyString } from "@insite/client-framework/Common/Utilities/DateUtilities";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@theStellarBlueprint/Store/CustomApplicationState";
import updatePurchasedItemsConfigSelection from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/Handlers/LoadPurchasedItemsConfigHandler";
import { getPurchasedItemsConfigSelectionState } from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/LoadPurchasedItemsConfigSelector";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => ({
    purchasedItemsConfig: getPurchasedItemsConfigSelectionState(state),
});

const mapDispatchToProps = {
    updatePurchasedItemsConfigSelection,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistoryDateRangeStyles {
    searchFieldWrapper?: SearchFieldWrapperStyles;
    datePickersWrapper?: InjectableCss;
    fromDate?: DatePickerPresentationProps;
    toDate?: DatePickerPresentationProps;
    clearFilters?: InjectableCss;
    dateItem?:GridItemProps;
    clearFilterGridItem?:GridItemProps;
}

export const dateRangeStyles: OrderHistoryDateRangeStyles = {
    fromDate: {
     
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
        },
    },
    toDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
        },
       
    },
    dateItem:{
        width:[12,12,12,4,4],
        css: css`
div:first-child{
    width:100%;
}
    `,
    },
    clearFilterGridItem:{
        width:[12,12,12,4,4],
        css: css`
        justify-content: flex-end;
        align-items: flex-end;
            `,
    },
};

const styles = dateRangeStyles;


const PurchasedItemsSearchFieldDateRange: React.FunctionComponent<Props> = props => {
    const tzOffset = new Date().getTimezoneOffset() * 60000;
const initfromDate = new Date(
    Date.now() - 90 * 60 * 60 * 24 * 1000 +tzOffset,
);
const today = new Date(
    Date.now() +tzOffset,
);

    const fromDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        if(selectedDay==null)
        {
            props.updatePurchasedItemsConfigSelection({
                Search:props.purchasedItemsConfig.Search,
                Description:props.purchasedItemsConfig.Description,
                fromDate: convertDateToDateOnlyString(initfromDate),
                toDate:props.purchasedItemsConfig.toDate,
            });
        }
        else{
            props.updatePurchasedItemsConfigSelection({
                Search:props.purchasedItemsConfig.Search,
                Description:props.purchasedItemsConfig.Description,
                fromDate:convertDateToDateOnlyString(selectedDay),
                toDate:props.purchasedItemsConfig.toDate,
            });
        }
       
    };

    const toDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
       if(selectedDay==null)
       {
        props.updatePurchasedItemsConfigSelection({
            Search:props.purchasedItemsConfig.Search,
            Description:props.purchasedItemsConfig.Description,
            fromDate:props.purchasedItemsConfig.fromDate,
            toDate:convertDateToDateOnlyString(today),
        });
       }
       else{
        props.updatePurchasedItemsConfigSelection({
            Search:props.purchasedItemsConfig.Search,
            Description:props.purchasedItemsConfig.Description,
            fromDate:props.purchasedItemsConfig.fromDate,
            toDate:convertDateToDateOnlyString(selectedDay),
        });
       }
        
    };

    const clearSearch = () => {
        props.updatePurchasedItemsConfigSelection({
                Search: "",
                Description:"",
                fromDate: initfromDate.toISOString().split("T")[0],
            toDate:convertDateToDateOnlyString(today),
            });
    };
    // replacing - with / prevents a date in the format "yyyy-mm-dd" from losing a day (doesn't add a time zone that can change the day)
    const fromDate = convertDateOnlyStringToDate(props.purchasedItemsConfig.fromDate);
    const toDate =convertDateOnlyStringToDate(props.purchasedItemsConfig.toDate);
    return (
      
             <GridContainer >
             <GridItem {...styles.dateItem}>
             <DatePicker
                    {...styles.fromDate}
                    label={translate("From")}
                    selectedDay={fromDate}
                    onDayChange={fromDateChangeHandler}
                    dateTimePickerProps={{
                        clearIcon: null,
                        maxDate: toDate,
                        ...styles.fromDate?.dateTimePickerProps,
                    }}
                />
             </GridItem>
             <GridItem {...styles.dateItem}>
             <DatePicker
                    {...styles.toDate}
                    label={translate("To")}
                    selectedDay={toDate}
                    onDayChange={toDateChangeHandler}
                    dateTimePickerProps={{
                        clearIcon: null,
                        minDate: fromDate,
                        maxDate:today,
                        ...styles.toDate?.dateTimePickerProps,
                    }}
                />
             </GridItem>
             <GridItem {...styles.clearFilterGridItem}>
             <Button {...styles.clearFilters} 
       data-test-selector="purchasedItems_clearFilters"
       onClick={clearSearch}
   >
       {translate("Clear Filters")}
   </Button>
             </GridItem>
                 </GridContainer>
        
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PurchasedItemsSearchFieldDateRange),
    definition: {
        group: "Basic",
        displayName: "Purchased Items Date Range",
    },
};

export default widgetModule;
